import { Fragment } from 'react';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { NavLink as RouterLink, useNavigate } from 'react-router-dom';

import { Divider, Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import useResponsive from '../../hooks/useResponsive';
import { getStorage } from '../../utils/storage';
import { ACCESS_TOKEN } from '../../store/types';
import { useRouter } from '../../hooks/useRoutes';


/* ======================================================================== */


export default function LauanCopyright() {
    const theme = useTheme();
    const { t } = useTranslation();
    const navigator = useNavigate();

    const isDesktop = useResponsive('up', 'lg');

    const accessToken = getStorage(ACCESS_TOKEN);

    const { onIcivetAuthorize } = useRouter();

    const links = [
      { txt: '法律與商標',   name: t('法律與商標'), link: () => navigator('/honhai/law-trademark') },
      { txt: '隱私權與政策', name: t('隱私權與政策'), link: () => navigator('/honhai/privacy-policy') },
      { txt: 'Cookie 政策', name: t('Cookie 政策'), link: () => navigator('/honhai/cookie-policy') },
      { txt: '網站地圖',  name: t('網站地圖'), link: () => accessToken ? navigator('/honhai/lauan/site-map') : onIcivetAuthorize() }
    ]

    return(
        <Stack
            direction={'row'}
            alignItems={'center'}
            sx={{
                justifyContent: 'flex-end',
                gap: 1.5,
                [theme.breakpoints.down('md')]: {
                justifyContent: 'center',
                gap: 1,
                },
            }}
        >
            {
                _.map(links, (item, index) => {
                    return (
                        <Fragment key={index}>
                            <Typography
                                onClick={() => item?.link && item?.link()}
                                lineHeight={0}
                                color={theme.colors.text.primary}
                                sx={{
                                cursor: 'pointer',
                                transition: 'all ease 0.3s',
                                textDecoration: 'auto',
                                '&:hover': {
                                    color: 'action.selected',
                                    boxShadow: '5px 10px 20px 2px rgba(84, 100, 142, 0.4)',
                                }
                                }}
                            >
                                { item?.name }
                            </Typography>
                            {
                                links?.length !== index + 1 && (
                                <Divider sx={{ height: 16, alignSelf: 'center', borderColor: theme.colors.text.primary }} orientation="vertical" variant="middle" flexItem />
                                )
                            }
                        </Fragment>
                    )
                })
            }
        </Stack>
    )
}
